@let isAdmin = user?.customer_admin;

<table-container [collection]="domains"
                 (onPageChange)="onPageChange.emit($event)"
                 (onPerPageChange)="onPerPageChange.emit($event)"
                 [progress]="progress">
    <table-container-top>
        <div class="mb-4 merge-r-16 merge-l-16 merge-t-16" *ngIf="isFiltersOpen">
            <table-filters [(open)]="isFiltersOpen"
                           (openChange)="isFiltersOpenChange.emit($event)"
                           [(ngModel)]="filters"
                           name="filters"
                           [filters]="availableFilters"
                           (onChanges)="onFiltersChanges.emit($event);filtersChange.emit($event)">
            </table-filters>
        </div>
    </table-container-top>
    <table class="table table-hover table-fixed table-pages table-with-labels projects-and-domains-table">
        <thead>
            <tr>
                <th class="col-sm-4 col-md-4 col-lg-4 text-center" translate>
                    Last Scan
                </th>
                <th monTableSort
                    [monSortBy]="'favorite'"
                    [monStartAsc]="true"
                    [monSortDirection]="sort.direction"
                    [monCurrentlySortedBy]="sort.by"
                    (monOnSorted)="onSort.emit($any($event))">
                    {{ 'Domain' | translate }}
                </th>
                <th class="col-sm-5 col-md-4 col-lg-4">
                    &nbsp;
                </th>
                <th class="col-sm-5 col-md-4 col-lg-4">
                    &nbsp;
                </th>
                <th class="col-sm-5 col-md-4 col-lg-4">
                    &nbsp;
                </th>
                <th class="col-sm-5 col-md-4 col-lg-4">
                    &nbsp;
                </th>
                <th class="col-sm-5 col-md-4 col-lg-4">
                    &nbsp;
                </th>
                <th class="col-sm-9 col-md-4 col-lg-4" [attr.aria-label]="'Documents crawled' | translate">
                    &nbsp;
                </th>
                <th class="col-sm-9 col-md-4 col-lg-4" [attr.aria-label]="'Pages crawled' | translate">
                    &nbsp;
                </th>
                <th class="col-sm-5 col-md-4 col-lg-4 text-right"></th>
                <th class="col-sm-7 col-md-4 col-lg-4 text-right">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let domain of domains; trackBy: trackByDomainId; let i = index">
                <tr [ngClass]="{'disabled': switchDomain !== null}"
                    [attr.aria-label]="('Open Domain' | translate) + ' ' + domain.title"
                    (mouseover)="onHover(domain)"
                    (mouseleave)="onHoverLeave(domain)">
                    @let rowDisabled=!(domain | hasDomainAccess);
                    <td class="text-v-middle text-center">
                        <div *ngIf="!domain.active"
                             [triggers]="'focus hover'"
                             [container]="'body'"
                             class="domain-without-scan-automatically"
                             [ngbTooltip]="domainStatusTooltipTemplate"
                             [tooltipContext]="$any({currentDomain: domain})">
                            <table-date *ngIf="domain?.crawl_history?.post_processing_done_at" [date]="domain?.crawl_history?.post_processing_done_at" aria-hidden="true"></table-date>
                            <span *ngIf="!domain?.crawl_history?.post_processing_done_at" class="text-grey" translate aria-hidden="true">Never scanned</span>
                        </div>
                        <div *ngIf="domain.active"
                             [triggers]="'focus hover'"
                             [container]="'body'"
                             class="domain-with-scan-automatically"
                             [ngbTooltip]="domainStatusTooltipTemplate"
                             [tooltipContext]="$any({currentDomain: domain})">
                            <table-date *ngIf="domain?.crawl_history?.post_processing_done_at" [date]="domain?.crawl_history?.post_processing_done_at" aria-hidden="true"></table-date>
                            <span *ngIf="!domain?.crawl_history?.post_processing_done_at" class="text-grey" translate aria-hidden="true">Never scanned</span>
                        </div>
                    </td>
                    <td class="text-v-middle" [attr.colspan]="getUnavailableModuleCount(domain)">
                        @let canAccessDomain = (domain | hasDomainAccess);
                        <pin-domain (callback)="getPage.emit(true)"
                                    [model]="domain"
                                    [active]="hoverDomain == domain.id"
                                    [disabled]="!canAccessDomain"
                                    (goto)="switchDomain === null && switchDomainGroup === null && canAccessDomain && goTo(domain)">
                        </pin-domain>
                        <label-table *ngIf="showLabels"
                                     [assignedLabels]="domain.labels || []"
                                     [existingLabels]="allLabels"
                                     [noLabelSelector]="!canEditDomainLabels"
                                     (onUpdateLabel)="updateDomain(domain)"
                                     (getLabels)="getLabels()">
                        </label-table>
                    </td>
                    <td class="vertical-align-middle"
                        [attr.colspan]="getNoDataWidth()"
                        (click)="openScanDetails(domain, $event)"
                        *ngIf="domain.crawl_status !== null">
                        <span translate class="pull-left mr-4 text-grey">
                            Scan in progress
                        </span>
                        <ngb-progressbar class="progress-striped active" [max]="100" [value]="domain.crawl_status?.progress || 0">
                        </ngb-progressbar>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToPoliciesModule(domain)">
                        <icon-button [positive]="'text-link'"
                                     [attr.data-test]="'policies-button-list'"
                                     [neutral]="'text-success'"
                                     [tooltip]="'Content Policies' | translate"
                                     [number]="(domain.crawl_history?.policy_with_violations_count || 0) + (domain.crawl_history?.policy_with_required_count || 0) + (domain.crawl_history?.policy_with_search_hits_count || 0)"
                                     [faIcon]="'fas fa-gavel'"
                                     [disabled]="!(domain | hasDomainAccess)"
                                     [monAriaIconText]="'Content Policies violations' | translate"
                                     [monAriaLabel]="'Content Policies' | translate"
                                     (callback)="toSection($event.event, 'policy', domain, null)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToQAModule(domain)">
                        <icon-button [positive]="'text-link'"
                                     [attr.data-test]="'qa-button-list'"
                                     [neutral]="'text-success'"
                                     [number]="domain.crawl_history?.qa_count"
                                     [tooltip]="'Content Quality' | translate"
                                     [faIcon]="'fas fa-check-square'"
                                     [disabled]="!(domain | hasDomainAccess)"
                                     [monAriaIconText]="'Content Quality errors' | translate"
                                     [monAriaLabel]="'Content Quality' | translate"
                                     (callback)="toSection($event.event, 'qa', domain, null)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToSEOModule(domain)">
                        <icon-button [positive]="'text-link'"
                                     [attr.data-test]="'seo-button-list'"
                                     [neutral]="'text-success'"
                                     [number]="domain.crawl_history?.seo_count"
                                     [tooltip]="'Search Engine Optimization (SEO)' | translate"
                                     [faIcon]="'fas fa-chart-line'"
                                     [disabled]="!(domain | hasDomainAccess)"
                                     [monAriaIconText]="'SEO errors' | translate"
                                     (callback)="toSection($event.event, 'seo', domain, null)">
                        >
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToDataPrivacyModule(domain)">
                        <icon-button positive="text-link"
                                     [attr.data-test]="'data-privacy-button-list'"
                                     neutral="text-success"
                                     [number]="domain.crawl_history?.data_protection_violations_count || 0"
                                     tooltip="{{'Data Privacy' | translate}}"
                                     faIcon="fas fa-lock-alt"
                                     [disabled]="rowDisabled || !domain.features?.data_protection"
                                     monAriaIconText="{{'Data privacy violations' | translate}}"
                                     monAriaLabel="{{'Data Privacy' | translate}}"
                                     (callback)="toSection($event.event, 'dataprivacy', domain)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToAccessibilityModule(domain)">
                        <icon-button positive="text-link" neutral="text-success"
                                     [attr.data-test]="'accessibility-button-list'"
                                     [disabled]="rowDisabled || (domain.features.accessibility ? !domain.features.accessibility.length : true)"
                                     [number]="domainAccCheckCount(domain.crawl_history?.accessibility_checks)"
                                     tooltip="{{'Accessibility' | translate}}"
                                     faIcon="fas fa-universal-access"
                                     monAriaIconText="{{'Accessibility errors' | translate}}"
                                     monAriaLabel="{{'Accessibility' | translate}}"
                                     (callback)="toSection($event.event, 'accessibility', domain)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="domain.crawl_status === null">
                        <icon-button positive="text-link"
                                     [attr.data-test]="'crawl-status-button-list'"
                                     neutral="text-success"
                                     [disabled]="rowDisabled || !domain.crawl_history || !domain.scan.scan_documents"
                                     [number]="domain.crawl_history?.documents_count || 0"
                                     tooltip="{{'Documents Crawled' | translate}}"
                                     faIcon="{{['TABS', 'PAGES', 'DOCUMENT'] | monIcons}}"
                                     monAriaIconText="{{'Documents Crawled' | translate}}"
                                     monAriaLabel="{{'Documents Crawled' | translate}}"
                                     (callback)="toSection($event.event, 'documents', domain)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="domain.crawl_status === null">
                        <icon-button positive="text-link"
                                     [attr.data-test]="'crawl-status-button-list'"
                                     neutral="text-success"
                                     [disabled]="rowDisabled || !domain.crawl_history"
                                     [number]="domain.crawl_history?.page_count || 0"
                                     tooltip="{{'Pages Crawled' | translate}}"
                                     faIcon="{{['TABS', 'PAGES', 'HTML'] | monIcons}}"
                                     monAriaIconText="{{'Pages Crawled' | translate}}"
                                     monAriaLabel="{{'Pages Crawled' | translate}}"
                                     (callback)="toSection($event.event, 'pages', domain)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle">
                        @if (domain.monsido_script_installed) {
                            <span class="d-none d-md-inline-block label label-success" translate>Script installed</span>
                            <span class="d-inline-block d-md-none text-success"
                                  [ngbTooltip]="'Script installed' | translate"
                                  placement="bottom"
                                  aria-hidden="true">
                                        <span class="fas fa-check"></span>
                            </span>
                        }
                    </td>
                    <td class="text-right text-v-middle">
                        @if (isAdmin) {
                            <domain-action-menu-button [domain]="domain"
                                                       [updating]="updatingDomains[domain.id]"
                                                       [user]="user"
                                                       [hasOnDemandScans]="hasOnDemandScans"
                                                       [scriptSetupGuideIsAvailable]="scriptSetupGuideIsAvailable"
                                                       (goToDomain)="goToDomain(domain)"
                                                       (openScriptGuide)="openScriptGuide(domain)"
                                                       (editDomain)="editDomain(domain, i)"
                                                       (editExcludedIps)="editExcludedIps(domain)"
                                                       (startOnDemandScan)="startOnDemandScan(domain)"
                                                       (cloneDomain)="cloneDomain(domain)"
                                                       (openDataPrivacy)="openDataPrivacy(domain)"
                                                       (updateDomainGroup)="updateDomainGroup(domain)"
                                                       (confirmDelete)="onConfirmDelete(domain)"
                                                       (stopCurrentCrawl)="stopCurrentCrawl(domain)"
                            />
                        }
                    </td>
                </tr>
                <tr *ngFor="let domain_group of domain.domain_groups | orderBy: 'title'; trackBy: trackByDomainGroupId; let $index = index"
                    [ngClass]="{'disabled': switchDomain !== null}">
                    <td class="text-center text-v-middle">
                        <div *ngIf="!domain.active"
                             container="body"
                             class="domain-without-scan-automatically"
                             [ngbTooltip]="domainStatusTooltipTemplate"
                             [tooltipContext]="$any({currentDomain: domain})"
                             tabindex="0"
                             role="cell"
                             attr.aria-label="{{'Last scan' | translate}}: {{ domain?.crawl_history?.post_processing_done_at ? (domain?.crawl_history?.post_processing_done_at | userDate:'ll') : ('Never scanned' | translate) }}. {{'Doesn't scan automatically' | translate}}">
                            <table-date *ngIf="domain?.crawl_history?.post_processing_done_at" [date]="domain?.crawl_history?.post_processing_done_at" aria-hidden="true"></table-date>
                            <span *ngIf="!domain.crawl_history?.post_processing_done_at" class="text-grey" translate aria-hidden="true">Never scanned</span>
                        </div>
                        <div *ngIf="domain.active"
                             container="body"
                             class="domain-with-scan-automatically"
                             [ngbTooltip]="domainStatusTooltipTemplate"
                             [tooltipContext]="$any({currentDomain: domain})"
                             tabindex="0"
                             role="cell"
                             attr.aria-label="{{'Last scan' | translate}}: {{ domain?.crawl_history?.post_processing_done_at ? (domain?.crawl_history?.post_processing_done_at | userDate:'ll') : ('Never scanned' | translate) }}. {{'Scans automatically' | translate}}">
                            <table-date *ngIf="domain?.crawl_history?.post_processing_done_at" [date]="domain?.crawl_history?.post_processing_done_at" aria-hidden="true"></table-date>
                            <span *ngIf="!domain?.crawl_history?.post_processing_done_at" class="text-grey" translate aria-hidden="true">Never scanned</span>
                        </div>
                    </td>
                    <td class="text-ellipsis text-v-middle domain-group-title-overview" [attr.colspan]="getUnavailableModuleCount(domain, domain_group)">
                        <span class="fas fa-clone domain-group-icon pull-left visibility-45" aria-hidden="true"></span>
                        <span class="sr-only" translate>Domain group</span>
                        <a (click)="switchDomain === null && goTo(domain, domain_group)"
                           [ngClass]="{'cursor-not-allowed disabled': switchDomain !== null, 'cursor-pointer': switchDomain === null}">
                           {{domain_group.title}}
                        </a>
                        <label-table *ngIf="showLabels"
                                     [assignedLabels]="domain_group.labels"
                                     [noLabelSelector]="true">
                        </label-table>
                    </td>
                    <td *ngIf="domain.crawl_status !== null" [attr.colspan]="getNoDataWidth()" class="text-v-middle">
                        <span class="noData" translate>Scan in progress</span>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToPoliciesModule(domain, domain_group)">
                        <icon-button positive="text-link"
                                     neutral="text-success"
                                     tooltip="{{'Content Policies' | translate}}"
                                     [number]="domain_group.policy_with_violations_count + domain_group.policy_with_required_count + domain_group.policy_with_search_hits_count"
                                     faIcon="fas fa-gavel"
                                     monAriaIconText="{{'Content Policies violations' | translate}}"
                                     monAriaLabel="{{'Content Policies' | translate}}"
                                     (callback)="toSection($event.event, 'policy', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToQAModule(domain, domain_group)">
                        <icon-button positive="text-link"
                                     neutral="text-success"
                                     [number]="domain_group.dead_links_count + domain_group.dead_images_count + domain_group.spelling_errors_confirmed_count"
                                     tooltip="{{'Content Quality' | translate}}"
                                     faIcon="fas fa-check-square"
                                     monAriaIconText="{{'Content Quality errors' | translate}}"
                                     monAriaLabel="{{'Content Quality' | translate}}"
                                     (callback)="toSection($event.event, 'qa', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToSEOModule(domain, domain_group)">
                        <icon-button positive="text-link"
                                     neutral="text-success"
                                     [number]="domain_group.seo_errors_alerts_count + domain_group.seo_errors_infos_count + domain_group.seo_errors_warnings_count"
                                     tooltip="{{'Search Engine Optimization (SEO)' | translate}}"
                                     faIcon="fas fa-chart-line"
                                     monAriaIconText="{{'SEO errors' | translate}}"
                                     monAriaLabel="{{'Search Engine Optimization' | translate}}"
                                     (callback)="toSection($event.event, 'seo', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToDataPrivacyModule(domain, domain_group)">
                        <icon-button positive="text-link"
                                     neutral="text-success"
                                     [disabled]="!domain.features.data_protection"
                                     [number]="domain_group.data_protection_violations_count || 0"
                                     tooltip="{{'Data Privacy' | translate}}"
                                     faIcon="fas fa-lock-alt"
                                     monAriaIconText="{{'Data privacy violations' | translate}}"
                                     monAriaLabel="{{'Data Privacy' | translate}}"
                                     (callback)="toSection($event.event, 'dataprivacy', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="hasAccessToAccessibilityModule(domain, domain_group)">
                        <icon-button positive="text-link" neutral="text-success"
                                     [disabled]="domain.features.accessibility ? !domain.features.accessibility.length : true"
                                     [number]="domainAccCheckCount(domain_group.accessibility_checks_counters)"
                                     tooltip="{{'Accessibility' | translate}}"
                                     faIcon="fas fa-universal-access"
                                     monAriaIconText="{{'Accessibility errors' | translate}}"
                                     monAriaLabel="{{'Accessibility' | translate}}"
                                     (callback)="toSection($event.event, 'accessibility', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="domain.crawl_status === null && domain_group.created_at">
                        <icon-button positive="text-link"
                                     neutral="text-success"
                                     [disabled]="!domain.scan.scan_documents"
                                     [number]="domain_group.documents_count || 0"
                                     tooltip="{{'Documents Crawled' | translate}}"
                                     faIcon="{{['TABS', 'PAGES', 'DOCUMENT'] | monIcons}}"
                                     monAriaIconText="{{'Documents Crawled' | translate}}"
                                     monAriaLabel="{{'Documents Crawled' | translate}}"
                                     (callback)="toSection($event.event, 'documents', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td class="text-v-middle" *ngIf="domain.crawl_status === null && domain_group.created_at">
                        <icon-button positive="text-link"
                                     neutral="text-success"
                                     [disabled]="false"
                                     [number]="domain_group.page_count || 0"
                                     tooltip="{{'Pages Crawled' | translate}}"
                                     faIcon="{{['TABS', 'PAGES', 'HTML'] | monIcons}}"
                                     monAriaIconText="{{'Pages Crawled' | translate}}"
                                     monAriaLabel="{{'Pages Crawled' | translate}}"
                                     (callback)="toSection($event.event, 'pages', domain, domain_group)">
                        </icon-button>
                    </td>
                    <td></td>
                    <td class="text-v-middle text-right">
                        @if (isAdmin) {
                            <domain-group-action-menu-button
                                    [updating]="updatingDomainGroups[domain.id]?.has(domain_group.id)"
                                    (goToDomainGroup)="goToDomain(domain, domain_group)"
                                    (editDomainGroup)="editDomainGroup(domain, domain_group)"
                                    (updateSingleDomainGroup)="updateSingleDomainGroup(domain.id, domain_group.id)"
                                    (confirmDeleteGroup)="onConfirmDeleteGroup(domain, domain_group)"
                            />
                        }
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</table-container>

<ng-template #domainStatusTooltipTemplate let-currentDomain="currentDomain">
    <div>
        <div>
            <span *ngIf="currentDomain?.active">{{ 'Scans automatically' | translate }}</span>
            <span *ngIf="!currentDomain?.active">{{ "Doesn't scan automatically" | translate }}</span>
        </div>
        <div>
            <span>{{ 'Last scan' | translate }}:</span>
            <span *ngIf="!currentDomain?.crawl_history?.post_processing_done_at">{{ 'Never scanned' | translate }}</span>
            <span *ngIf="currentDomain?.crawl_history?.post_processing_done_at">{{ currentDomain.crawl_history?.post_processing_done_at | userDate:'LL' }}</span>
        </div>
    </div>
</ng-template>
